<template>
    <div class="seventh">
        <div class="seventh-bg">
            <header>
                <img src="../assets/logo.svg">
            </header>
        </div>
        <div v-show="scoreB" class="score">
            <div class="title-box">
                <h2>本次营销效果的综合得分<span>Score of the performance of this campaign</span></h2>
                <h3><span><b>{{score}}</b></span></h3>
            </div>
            <div class="submitBox">
                <div class="from-control">
                    <input type="text" placeholder="留下您的大名，记录英雄榜" class="" v-model="name"/>
                    <div class="button">
                        <button @click="showList" class="btn">submit</button>
                    </div>
                </div>

            </div>
        </div>

        <div class="modal" :style="showI">
            <div class="modal-box">
                <h3>Ranking List</h3>
                <div class="rank-box">
                    <ul>
                        <li :key="index" v-for="(item,index) in personA">
                            <div class="rank">
                                <img src="../assets/ranking-0.jpg" v-if="index==0">
                                <img src="../assets/ranking-1.jpg" v-else-if="index==1">
                                <img src="../assets/ranking-2.jpg" v-else-if="index==2">
                                <span v-else>{{index + 1}}</span>
                            </div>
                            <div class="rank-num">
                                <span>{{item.name}}<img @click="delRank(index)" class="del-rank" src="static/del.png"/></span>
                                <span><img src="../assets/ranking.svg" width="14"/><b>{{item.rank}}分</b></span>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="btn">
                </div>
            </div>
        </div>

        <div class="admin">
            <div class="admin-box">
                <div class="edit" @click="showAdmin(admin)"><img src="static/edit.png"/></div>
                <div v-show="admin" class="from">
                    <div class="close" @click="showAdmin(admin)"><img src="static/del.png"/></div>
                    <div class="from-control"><input type="text" placeholder="姓名" v-model="name"/></div>
                    <div class="from-control"><input type="text" placeholder="分数" v-model="score"/></div>
                    <button class="btn" @click="showList">Submit</button>
                </div>
            </div>
        </div>

        <alert v-if="show" @showbox="toshow" :show="show" :msg="msg"></alert>

    </div>
</template>
<style>
    .seventh header {
        background: none;
    }

    .seventh-bg {
        background: url('../assets/seventh.jpg') no-repeat;
        min-height: 285px;
        background-size: cover;
    }

    .title-box{display: flex;width: 38%;margin: 0 auto}

    .score h2 {
        text-align: center;
        font-weight: 400;
        font-size: 36px;
        color: #535b68;
        padding: 5px 0;
    }

    .score h2 span {
        font-size: 19px;
        display: block;
        color: #9b9ea7;

    }
    .score h3 span{
        padding: 15% 0 0 7%;
        display: block;
    }
    .score h3 span b {
        font-size: 60px;
        color: #ff2366;
        line-height: 60px;
        display: inline-block;
        padding-left: 15px;
    }



    .score .from-control {
        width: 39%;
        position: relative;
        min-height: 62px;
    }

    .score .from-control input {
        width: 100%;
        padding: 15px;
        border-radius: 50px;
        box-shadow: 2px 2px 13px 3px #eee;
        border: none
    }

    .score .button .btn {
        font-size: 14px;
        padding: 14px 26px;
        border-radius: 0 50px 50px 0;
        background: linear-gradient(to right, #022282, #0575e6);
        color: #fff;
        cursor: pointer;
    }

    .submitBox {
        text-align: center;
        display: flex;
        justify-content: center;
    }

    .score .submitBox .button {
        position: absolute;
        right: -30px;
        top: -1px;
    }

    /*.modal{display: flex;justify-content:center;}*/
    .modal-box {
        background: #fff;
        border-radius: 3px;
        box-shadow: 1px 1px 3px 1px #eee;
        border: none;
        width: 30%;
        position: fixed;
        top: 15%;
        left: 35%;
        min-height: 525px;
    }

    ul {
        list-style-type: none;
    }

    .modal-box h3 {
        color: #535b68;
        font-size: 34px;
        text-align: center;
        font-weight: 300;
        margin: 20px 0 0 0;
    }

    .rank-box li {
        display: flex
    }

    .rank-box ul {
        padding: 0 30px;
        margin: 20px 0 40px 0;

    }

    .rank-box li .rank img {
        width: 28px;
        height: 28px;
        display: inline-block;
        padding-top: 10px;
    }

    .rank {
        width: 10%;
        text-align: center
    }

    .rank-num {
        width: 85%;
        margin-left: 5%;
        border-bottom: 1px solid #eeeeee;
        padding-bottom: 5px;
        position: relative;
    }

    .rank-num span {
        display: block;
        color: #535b68;
        font-size: 22px;
    }

    .rank-box li .rank-num span b {
        font-size: 15px;
        font-weight: 100;
        color: #ffc000;
        display: inline-block;
        padding-left: 10px;
    }

    .rank-box li .rank-num span img {
        vertical-align: middle;
    }

    .del-rank{
        position: absolute;
        width: 25px;
        height: 25px;
        right: 0;
        display: none;
        top:5px;
        cursor: pointer;
    }

.rank-num:hover .del-rank{
    display: block;
}


    .modal-box .btn {
        text-align: center;
        width: 100%;
        margin-bottom: 30px;
    }

    .modal-box button {
        color: #021b79;
        border: 1px solid #021b79;
        padding: 10px 30px;
        border-radius: 50px;
        text-align: center;
        cursor: pointer
    }

    .admin{
        position: absolute;
        right: 2%;
        bottom: 16%;
        width: 16%;
    }
    .admin-box{position: relative;}
    .admin .edit{cursor: pointer;width: 100%;text-align: center;}
    .admin .from{
        box-shadow: 2px 2px 13px 3px #eee;
        border: none;
        position: absolute;
        bottom: 104%;
        padding: 20px 0;
        border-radius: 3px;
        background: #fff;

    }
    .admin .from .close{position: absolute;cursor: pointer;
        right: -20px;
        top: -20px;}
    .admin .from .from-control{width: 100%;
        position: relative;}
    .admin .from .from-control input{
        box-shadow: 2px 2px 13px 3px #eee;
        border: none;
        border-radius: 50px;
        font-size: 14px;
        padding:10px 15px;
        margin: 10px 15px 5px;
        width: 70%;

    }
    .admin .from  .btn{             font-size: 14px;
        padding: 10px 26px;
        border-radius: 50px;
        background: linear-gradient(to right, #022282, #0575e6);
        color: #fff;
        cursor: pointer;width: 85%;margin: 10px 15px 0;}
    .admin .from .from-control input::placeholder{color: #ccc}
    .admin .edit img{width: 60px;height: 60px;cursor: pointer}

    @keyframes modalOut {
        0% {
            opacity: 0.5;
            top: 0%;
        }
        100% {
            opacity: 1;
            top: 15%;
        }
    }
</style>
<script>

    import Alert from './alert.vue';

    export default {
        name: 'seventh',
        components: {
            "alert": Alert
        },
        data () {
            return {
                score: "",
                name: '',
                show: false,
                scoreB:false,
                admin:false,
                msg:'请填写姓名',
                personA: [
                ],
                person: [],
                showI: {display: 'block'},
            }
        },
        methods: {
            toshow(show){
                this.show = show;
            },
            compareDown(propertyName) { // 降序排序

                    return function(object1, object2) { // 属性值为数字
                        var value1 = object1[propertyName];
                        var value2 = object2[propertyName];
                        return value2 - value1;
                    }

            },
            showAdmin(show){
               this.admin = !show
            },
            delRank(index){
               this.personA.splice(index,1);
               let c =JSON.stringify(this.personA.sort(this.compareDown("rank"))) ;
                this.person =this.personA.sort(this.compareDown("rank"))
               localStorage.setItem("person", c);
                        this.show = true
                        this.msg ="删除成功，列表已更新"
            },
            showList(){
                if (this.name == '') {
                    this.show = true;
                    this.msg ="名字不能为空"
                }else if(this.score>100||this.score<0){
                    this.show = true;
                    this.msg ="分数只能是0-100的数字"
                }else if(typeof parseInt(this.score) !== "number"){
                    this.show = true;
                    this.msg ="分数只能是0-100的数字"
                } else {
                    let b = {};
                    b.name = this.name;
                    b.rank = this.score;
                    this.personA.push(b);
                    let c =JSON.stringify(this.personA.sort(this.compareDown("rank"))) ;
                    this.person =this.personA.sort(this.compareDown("rank"))

                    localStorage.setItem("person", c);
                    if(this.person !== []){
                        this.showI.display = "block";
                        this.scoreB = false
                        this.show = true
                        this.msg ="列表已更新"
                        this.admin = false;
                        this.name = ""
                        this.score = ""
                    }

                }
            },
            readData(){
                let a = localStorage.getItem("person");
                if(a){
                    this.personA =JSON.parse(localStorage.getItem("person"));
                }else{
                    this.personA =[]

                }
                //this.score = sessionStorage.getItem("rank");
            }
        },
        created(){
            this.readData();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/rank.vue